import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs } from 'cerialize';
import { ITransitProgramRequirementStatus } from '../interfaces';
import { DocumentType } from './document-type';

export class DocumentTypeStatus implements ITransitProgramRequirementStatus {
  @autoserialize
  driverId: number;

  @autoserialize
  vehicleId: number;

  @autoserialize
  transitProgramCode: string;

  @autoserializeAs(DocumentType)
  documentType: DocumentType;

  @autoserialize
  status: string;

  @autoserialize
  rejectionComments: string;

  @autoserializeAs(Date)
  requiredByDate: Date;

  @autoserializeAs(Date)
  lastUpdatedDate: Date;

  /**** Serialization ****/

  static OnSerialized(instance: DocumentTypeStatus, json: any): void {
    if (!isNullOrUndefined(instance.lastUpdatedDate)) {
      json.lastUpdatedDate = DateUtil.serializeDate(instance.lastUpdatedDate);
    }

    if (!isNullOrUndefined(instance.requiredByDate)) {
      json.requiredByDate = DateUtil.serializeLocalDate(instance.requiredByDate);
    }
  }

  static OnDeserialized(instance: DocumentTypeStatus, json: any): void {
    if (!isNullOrUndefined(json['lastUpdatedDate'])) {
      instance.lastUpdatedDate = DateUtil.deserializeDate(json['lastUpdatedDate']);
    }

    if (!isNullOrUndefined(json['requiredByDate'])) {
      instance.requiredByDate = DateUtil.deserializeLocalDate(json['requiredByDate']);
    }
  }
}
